import { CheckCircleFilled } from "@ant-design/icons";
import { Button } from "antd";
import Container from "components/Desktop/Container";
import Header from "components/Desktop/Header";
import MobileContainer from "components/Mobile/Container";
import MobileHeader from "components/Mobile/Header";
import { IS_BREAKPOINT_DESKTOP } from "constants/common";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import qrNarin from "src/assets/qr_narin.png";

const RegisterSuccessPage = () => {
  const navigation = useNavigate();
  const isDesktop = useMediaQuery({
    query: IS_BREAKPOINT_DESKTOP,
  });

  const content = (
    <main className="min-h-[700px] bg-[#F7F4FA] pt-8 p-4 flex justify-center">
      <div className="w-full max-w-[800px] flex flex-col items-center gap-4 pt-8">
        <CheckCircleFilled className="text-[64px] text-[#00AA86]" />
        <div className="text-2xl font-semibold text-center">
          สมัครสมาชิกสำเร็จแล้ว
        </div>
        <img
          src={qrNarin}
          alt="LINE QR Code"
          width={260}
          height={260}
          className="max-w-full"
        />
        <div className="text-center text-xl font-semibold">@narinonline</div>
        <div className="text-center">
          รบกวนแอดไลน์เพื่อนคอนเฟิร์ม order ในการสั่งสินค้า
        </div>
        <Button
          type="primary"
          size="large"
          className="w-[250px] mt-4"
          onClick={() => navigation("/authen?tab=login")}
        >
          ตกลง
        </Button>
      </div>
    </main>
  );

  if (isDesktop) {
    return (
      <div>
        <Container>
          <Header />
        </Container>
        <Container>{content}</Container>
      </div>
    );
  }

  return (
    <div>
      <MobileContainer>
        <MobileHeader />
        {content}
      </MobileContainer>
    </div>
  );
};
export default RegisterSuccessPage;
